



















import api from '@/services/api';
import { Component, Vue } from 'vue-property-decorator';
import { LoginRoute } from '@/services/Authorize';
import 'bootstrap';
import bootbox from 'bootbox';
import _ from 'underscore';

@Component
export default class ForgotPassword extends Vue {

    private emailAddress: string = '';

    get LoginRoute(): string {
        return LoginRoute;
    }

    public sendForm() {

        const data = {
            emailAddress: this.emailAddress
        };

        if (_.isEmpty(data.emailAddress)) {
            return bootbox.alert('Please enter an Email Address.');
        }

        api().post('/forgot_password', data)
            .finally(() => {

                const message = `An email has been sent to this address with instructions on how to reset your password.`;

                bootbox.alert(message, () => {
                    this.$router.push(LoginRoute);
                });
            });
    }
}
